import axios from "axios"
import { Apis } from "constants/apis"
import { ResendService } from "types/services"

const resendCode: ResendService = async (payload) => {
    const { data } = await axios.post(Apis.RESEND_CODE, payload);
    return data
}

export default resendCode